import React, { Suspense } from 'react';

const Editor = React.lazy(() => import(/* webpackChunkName: 'editor' */ './JSONEditor'));

const JSONEditor = (props) => {
  return (
    <Suspense fallback="Loading">
      <Editor {...props} />
    </Suspense>
  );
};

export default JSONEditor;



// WEBPACK FOOTER //
// src/components/shared/JSONEditor/index.jsx